import createIcon from '../../createIcon';

/**
 * @component @name Brightness5
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMzUzNCkiPgo8cGF0aCBkPSJNMjAuMDAwNCAxNS4zMDk1TDIzLjMxMDQgMTEuOTk5NUwyMC4wMDA0IDguNjg5NDVWMy45OTk0NUgxNS4zMTA0TDEyLjAwMDQgMC42ODk0NTNMOC42OTA0MyAzLjk5OTQ1SDQuMDAwNDNWOC42ODk0NUwwLjY5MDQzIDExLjk5OTVMNC4wMDA0MyAxNS4zMDk1VjE5Ljk5OTVIOC42OTA0M0wxMi4wMDA0IDIzLjMwOTVMMTUuMzEwNCAxOS45OTk1SDIwLjAwMDRWMTUuMzA5NVpNMTIuMDAwNCAxNy45OTk1QzguNjkwNDMgMTcuOTk5NSA2LjAwMDQzIDE1LjMwOTUgNi4wMDA0MyAxMS45OTk1QzYuMDAwNDMgOC42ODk0NSA4LjY5MDQzIDUuOTk5NDUgMTIuMDAwNCA1Ljk5OTQ1QzE1LjMxMDQgNS45OTk0NSAxOC4wMDA0IDguNjg5NDUgMTguMDAwNCAxMS45OTk1QzE4LjAwMDQgMTUuMzA5NSAxNS4zMTA0IDE3Ljk5OTUgMTIuMDAwNCAxNy45OTk1WiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDAyXzIzNTM0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Brightness5 = createIcon('Brightness5', [
  ['g', { clipPath: 'url(#clip0_2402_23534)', key: '12kvrq' }],
  ['defs', { key: '9ahrjx' }],
]);

export default Brightness5;
